// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gimA","right":"styles_right__3LY_h"};